import { Component, OnInit, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'statistics-linechart',
  templateUrl: './t_linechart.component.html',
  styleUrls: ['./linechart.component.less']
})
export class LinechartComponent implements OnInit {

  public isFullsized:boolean = false;

  public title: string = '';
  @Input() fullPage:boolean = false;

  @ViewChild('chart') chart;

  options = {
    xAxis: {
        type: 'category',
        data: ['JAN','FEV','MARS','AVR','MAI','JUIN','JUIL','AOUT','SEPT','OCT','NOV','DEC']
    },
    yAxis: {
        type: 'value'
    },
    calculable: true,
    series: [],
    color: [],
    legend: {
      data: []
    }
  };


  constructor() { }

  ngOnInit() {
  }

  setTitle(title)
  {
    this.title = title;
  }

  setChartData(chartData)
  {
    this.removeAllChart();
    
    setTimeout(()=>{
    chartData.forEach((line, index)=>{
      this.options.series.push({
        name: line.label,
        data: line.data,
        type: "line",
        smooth: true,
        stack: line.label,
        label: {
          show: true
        }
      });
      this.options.color.push(line.color);
      this.options.legend.data.push(line.label);
    });
    }, 1);
  }

  removeAllChart()
  {
    this.options.series = [];
    this.options.color = [];
    this.options.legend.data = [];
  }
  
  onChartClick(event)
  {
  	this.isFullsized = !this.isFullsized;
  }
}
